angular.module('shared').factory('isInteger', function() {
  return function(number) {
    return parseInt(number, 10) === parseFloat(number);
  };
});
